import { render, staticRenderFns } from "./MStoreRetentionTab.vue?vue&type=template&id=04ce4262&"
import script from "./MStoreRetentionTab.vue?vue&type=script&lang=ts&"
export * from "./MStoreRetentionTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports